import { render, staticRenderFns } from "./BuyersManagementHeader.vue?vue&type=template&id=369d803a&"
import script from "./BuyersManagementHeader.vue?vue&type=script&lang=ts&"
export * from "./BuyersManagementHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BuyersManagementHeader.vue?vue&type=style&index=0&id=369d803a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports